module.exports = __webpack_public_path__ + "img/img-2.5989a876.jpg";